import axios from 'axios';
import { Message, MessageBox, Loading } from 'element-ui';
import { getToken } from '@/utils/auth';
import systemConfig from '@/config';

// 创建axios实例
const service = axios.create({
  baseURL: systemConfig.baseURL || 'function', // api 的 base_url
  timeout: 60000, // 请求超时时间
});

let ajaxCount = 0;
let loadingInstance;
// request拦截器
service.interceptors.request.use(
  (config) => {
    // if (process && process.env && process.env.NODE_ENV === 'development') {
    //   config.url = config.url.replace(
    //     /^\/luban-job-management-service/gi,
    //     '/test-luban-job-management-service',
    //   );
    // }
    ajaxCount += 1;
    if (ajaxCount > 0) {
      loadingInstance = Loading.service({ fullscreen: true });
    }
    config.headers.token = 'login_d9256c50-8b82-11e9-b8bd-466a6ed4df35'; // 让每个请求携带自定义token 请根据实际情况自行修改
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  },
);

// response 拦截器
service.interceptors.response.use(
  (response) => {
    setTimeout(() => {
      ajaxCount -= 1;
      if (ajaxCount < 1 && loadingInstance) {
        loadingInstance.close();
      }
    }, 10);
    if (response.config.responseType === 'arraybuffer') {
      return response.data;
    }
    /**
     * error_no为非0是抛错
     */
    const res = response.data;
    if ((res.err_no && res.err_no !== 0) || (res.error_no && res.error_no !== 0)) {
      Message({
        message: res.error_msg || res.err_msg,
        type: 'error',
        duration: 5 * 1000,
      });
      return Promise.reject(res);
    }
    return response.data;
  },
  (error) => {
    setTimeout(() => {
      ajaxCount -= 1;
      if (ajaxCount < 1 && loadingInstance) {
        loadingInstance.close();
      }
    }, 10);
    console.log(`err${error}`); // for debug
    const { response } = error;
    Message({
      message: (response.data && response.data.error_msg) || error.message,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default service;
